// Realistic placeholder copy for previewing templates BEFORE the AI
// fills the real slots. Used by:
//   - /social-template-builder (live preview while authoring)
//   - StepSocialDesign picker (thumbnail preview of each JSON template)
//
// Mirrors the AI-fill shape from /api/suggest-copy?format=social-post-12-slot.
// Keep field shape in sync with SocialPostSlots in lib/api.ts.

import type { SocialPostSlots } from '@/lib/api';

export const SAMPLE_SLOTS: SocialPostSlots = {
  eyebrow: 'NEW · LIMITED EDITION',
  headline: 'A Quiet <em>Moment</em>',
  subhead: 'Crafted for the everyday with the care of a ritual.',
  bullet1: '· Hand-finished detail',
  bullet2: '· 100% recycled materials',
  bullet3: '· Free shipping over $50',
  cta: 'Shop now',
  handle: '@yourbrand',
  badge_stars: '★★★★★',
  badge_text: '4.9 · 2.3k reviews',
  brand_name: 'Yourbrand',
  brand_tagline: 'Crafted for the everyday',
  issue_label: 'No. 01',
  caption_left: 'Soft / Refined',
  caption_right: 'Made to last',
  body: 'A single product designed to streamline your routine. Made from sustainable materials with attention to every detail.',
  bullet_list: 'Hand-finished detail\n100% recycled materials\nFree shipping over $50\nLifetime warranty',
  // Generic labels — sample content for preview. Real templates use
  // them as catch-alls for content that doesn't fit the named slots.
  label_1: 'Label one',
  label_2: 'Label two',
  label_3: 'Label three',
  label_4: 'Label four',
  label_5: 'Label five',
  label_6: 'Label six',
  label_7: 'Label seven',
  label_8: 'Label eight',
};
